import type { TaskForType } from '@econtractor/types';

/** Службовий маркер у reject_comment для подій зміни прив'язки */
export const BINDING_HISTORY_MARKER = '__BINDING__';

export interface BindingHistoryLabels {
    personal: string;
    lead: string;
    object: string;
    sale: string;
    service: string;
}

export const bindingEntityLabel = (
    taskFor: TaskForType,
    name: string,
    labels: BindingHistoryLabels,
): string => {
    if (taskFor === 'personal') return labels.personal;
    const title = String(name || '').trim() || '—';
    if (taskFor === 'lead') return `${labels.lead}: ${title}`;
    if (taskFor === 'sale') return `${labels.sale}: ${title}`;
    if (taskFor === 'service') return `${labels.service}: ${title}`;
    return `${labels.object}: ${title}`;
};

export const buildBindingHistoryComment = (fromLabel: string, toLabel: string): string => {
    const from = String(fromLabel || '').trim() || '—';
    const to = String(toLabel || '').trim() || '—';
    return `${BINDING_HISTORY_MARKER}\n${from} → ${to}`;
};
